import { forwardRef } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Input as SemanticInput } from "semantic-ui-react";
import "./input.scss";

export const Input = forwardRef(({ className = "", ...props }, ref) => {
  return (
    <SemanticInput
      {...props}
      ref={ref}
      className={clsx("ha-input", className)}
    />
  );
});

Input.displayName = "Input";

Input.propTypes = {
  className: PropTypes.string,
};
